import {ReactComponent as ScanIcon} from '../assets/icons/main/scan-icon.svg';
import { Button, Typography, OutlinedInput, Grid } from "@mui/material";
import { ReactComponent as VrLine } from '../assets/icons/main/verticalLine.svg';

const Header = ({ gateway, asset, service }: any) => {

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item>
        <Grid container direction="row" justifyContent="flex-start" gap="32px" alignItems="center">
          <Grid item>
            {gateway &&
              <Typography variant="subtitle1" color="#64759F">
                Gateway:<span style={{ color: "#434D67" }}>{gateway}</span></Typography>}
          </Grid>
          <Grid item>
            {asset && <Typography variant="subtitle1" color="#64759F">
              Asset:<span style={{ color: "#434D67" }}>{asset}</span></Typography>}
          </Grid>
          <Grid item>
            {service && <Typography variant="subtitle1" color="#64759F">
              Service:<span style={{ color: "#434D67" }}>{service}</span></Typography>}
          </Grid>
          <Grid item>
              <VrLine />
            </Grid>
            {!asset &&
            <>
              <Grid item>
                <Typography>CIDR(s) to Scan</Typography>
              </Grid>
              <Grid item>
                <OutlinedInput style={{ marginRight: "32px" }} />
              </Grid>
              </>
            }
          <Grid item>
          <Button variant="contained" startIcon={<ScanIcon/>} sx={{marginRight : 1}} >
              Scan
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          gap="32px"
        >
          <Grid item>
              <Button variant="contained" size="small">save</Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Header;